import "./views/shared/partials/_topCitiesList.js";
import "./views/fd-pkgs/fd-location/partials/_switchRegion.js";
import "./views/fd-pkgs/fd-header/desktop/partials/_searchResults.js";
import "./views/desktop/shared/_pagination.js";